export default __webpack_public_path__ + "static/media/hand_made.c4bc9373.jpeg";